<template>
  <div>
    <router-view v-if="$route.params.promotionDepartmentId" />
    <Promotions v-else />
  </div>
</template>

<script>
import Promotions from "@/views/Promotions/Promotions.vue";

export default {
  name: "PromotionsView",
  components: { Promotions },
};
</script>
